import translations from '@/translations/translations.json'

const languages = {
  en_GB: 'English',
  mk_MK: 'Macedonian',
  sq_AL: 'Albanian',
  sr_RS: 'Serbian'
}

const translateConfig = {
  availableLanguages: languages,
  defaultLanguage: (localStorage.language &&
      languages[localStorage.language]) ? localStorage.language : 'mk_MK',
  translations: translations
}

const veeValidateLangMapping = {
  en_GB: 'en',
  mk_MK: 'bg',
  sq_AL: 'sq',
  sr_RS: 'sr'
}

export { translateConfig, veeValidateLangMapping }
